export const TOUR_PORTAL_ID = "tourGuideTarget";
export const TOUR_ANCHOR_PREFIX = "--tour-";

export const TOUR_Z_BACKDROP = 9000;
export const TOUR_Z_HIGHLIGHT = 9001;
export const TOUR_Z_TOOLTIP = 9002;

export const TOUR_ANIMATION_MS = 250;

export const HIGHLIGHT_RING_INSET_PX = -6;
export const TOOLTIP_OFFSET_PX = 16;
export const TOOLTIP_MAX_WIDTH_PX = 327;
export const TOOLTIP_MIN_WIDTH_PX = 200;
export const VIEWPORT_SAFE_MARGIN_PX = 16;

export const ARROW_WIDTH = 16;
export const ARROW_HEIGHT = 8;
export const ARROW_OVERLAP_PX = 1;

export const toAnchorVar = (name: string): string =>
  `${TOUR_ANCHOR_PREFIX}${name}`;
